"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "MissionControl___StyledSvg",
  componentId: "sc-15cq9r9-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function MissionControl(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.755 16.392c.167 0 .389-.024.5-.136.185-.185.309-.982-.54-2.68-.364-.726-.851-1.5-1.428-2.29a28.57 28.57 0 01-2.991 2.996c1.899 1.382 3.542 2.11 4.46 2.11zm-12.01-.136c.112.112.333.136.5.136.917 0 2.561-.728 4.459-2.11a28.564 28.564 0 01-2.99-2.995c-.578.789-1.065 1.563-1.428 2.29-.849 1.697-.726 2.494-.542 2.679zm.5-12.647c-.167 0-.388.024-.5.135-.428.428.055 2.36 1.964 4.972a28.95 28.95 0 012.995-2.998c-1.898-1.382-3.542-2.11-4.46-2.11zm7.461 8.098a28.343 28.343 0 001.568-1.705 27.859 27.859 0 00-1.568-1.708A26.792 26.792 0 0010 6.74a26.33 26.33 0 00-3.274 3.263A26.276 26.276 0 0010 13.26c.56-.472 1.13-.978 1.706-1.553zm4.55-7.963c-.112-.111-.334-.135-.5-.135-.918 0-2.561.727-4.46 2.11a28.951 28.951 0 012.996 2.997c1.909-2.611 2.39-4.544 1.964-4.972zm.897 9.113c-.455-.91-1.074-1.879-1.818-2.86 2.252-2.971 3.464-5.984 2.058-7.39C17.116 2.33 16.607 2 15.755 2c-1.463 0-3.557.995-5.755 2.664C7.802 2.994 5.708 2 4.245 2c-.852 0-1.36.33-1.638.606-1.406 1.407-.194 4.42 2.059 7.392-.744.98-1.364 1.95-1.82 2.859-1.315 2.632-.856 3.919-.239 4.536.278.277.786.607 1.638.607 1.463 0 3.557-.994 5.755-2.665C12.198 17.005 14.292 18 15.755 18c.852 0 1.361-.33 1.638-.607.617-.617 1.076-1.904-.24-4.536z",
    fill: "currentColor"
  }), _react["default"].createElement("path", {
    d: "M11 10a1 1 0 11-2 0 1 1 0 012 0z",
    fill: "currentColor"
  }));
}

var _default = MissionControl;
exports["default"] = _default;